<template>
    <v-row justify="center">
    <v-dialog v-model="dialogLocal" width="450">
      <v-card>
        <v-form ref="es" action="#" @submit.prevent="beforeCreateForm('create')" lazy-validation>
        <v-card-title class="justify-space-between" :style="{'background-color': topbarcolor}" style="color: white; padding-top: 5px; padding-bottom: 5px">
          <span class="headline">Manual Entry</span>
          <v-btn text @click="$emit('closed', false)" fab depressed small><v-icon small color="white">fas fa-times</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-row>

                <v-col cols="12" md="12">
                    <v-overlay
                        :absolute="true"
                        :opacity="1"
                        :z-index="999"
                        :value="modal_loader"
                        color="#D2D7DF"
                        >
                        <v-progress-circular indeterminate size="100"></v-progress-circular>
                    </v-overlay>
                    <v-autocomplete
                    dense
                    outlined
                    placeholder="Select Car Park"
                    label="Car Park"
                    v-model="form.carpark.selected"
                    :items="form.carpark.items"
                    item-text="name"
                    item-value="CarParkID"
                    :rules="form.carpark.rule"
                    :loading="form.carpark.loader"
                    :disabled="form.carpark.disable"
                    />
                    <v-text-field
                        dense
                        outlined
                        v-model="form.bayno.item"
                        :rules="form.bayno.rule"
                        label="Bay No. *"
                    ></v-text-field>
                    <vc-date-picker v-model="form.requestedticketentrydatetime.item" popover :disabled-dates='disabled_dates' mode="datetime" locale="en-GB" :max-date='new Date()'>
                    <template v-slot="{ inputValue, inputEvents, togglePopover }">
                        <v-row dense>
                            <v-col cols="12" sm="12" md="12">
                                <div
                                v-bind:class="validateStartDateMain"
                                class="v-input v-input--is-label-active v-input--is-dirty v-input--dense theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
                                <div class="v-input__control">
                                <div class="v-input__slot white">
                                    <fieldset aria-hidden="true"><legend :style="focused || form.requestedticketentrydatetime.item ? {'width': '49px'} : {'width': '0px'}"><span>&#8203;</span></legend></fieldset>
                                    <div class="v-text-field__slot">
                                    <label for="input-startdate" v-bind:class="validateStartDate" class="v-label theme--light" style="left: 0px; right: auto; position: absolute;">Entry Date *</label>
                                    <input
                                    id="input-startdate"
                                    @focus="focused = true"
                                    @blur="focused = false"
                                    :value="inputValue"
                                    v-on="inputEvents"
                                    @click="togglePopover({ placement: 'top-start', visibility: 'click', positionFixed: true })"
                                    autocomplete="off"
                                    />
                                    </div>
                                </div>
                                <div class="v-text-field__details">
                                    <v-input
                                        error
                                        readonly
                                        v-model="form.requestedticketentrydatetime.item"
                                        :rules="form.requestedticketentrydatetime.rule"
                                        height="0"
                                        class="hide-input-text"
                                    >
                                    </v-input>
                                </div>
                                </div>
                                </div>
                            </v-col>
                        </v-row>
                    </template>
                    </vc-date-picker>
                </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-btn v-if="!readonly" tile type="submit" small color="primary"><v-icon left x-small dark>fa fa-save</v-icon>Save</v-btn>
            <v-spacer></v-spacer>
            <v-btn tile color="blue darken-1" text @click="$emit('closed', false)">Close</v-btn>
        </v-card-actions>
        </v-form>
        <alertbox :dialog="innerModal" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" @confirm="onConfirm" @closed="onClosed"></alertbox>
      </v-card>
    </v-dialog>
    </v-row>
</template>

<script>
import alertbox from './Alert';
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
import * as moment from "moment";

  export default {
    props: ['dialog', 'modalInfo', 'customText', 'carpark', 'master', 'readonly', 'allInfo', 'category', 'issue'],

    data() {
        return {
            dialogLocal: false,
            tableloading: false,
            swal: {
                notification: false,
                message: '',
                scolor: '',
            },
            innerModal: false,
            ma: {
                modal: false,
                modal_action_type: '',
                modalInfo: [],
                customText: [],
                edit_modal: false,
                view_modal: false,
                confirmEdit: false,
                confirmCreate: false,
            },
            form: {
                operator:{item: [], itemsFull: [], rule: [], selected: ''},
                carpark: {item: [], itemsFull: [], rule: [], selected: '' },
                bayno: {item: "", rule: []},
                parkingtokenamountmyr: {item: "", rule: []},
                valuepasspassid: {item: "", rule: []},
                finalparkingamountmyr: {item: "", rule: []},
                pmethod: {
                    items: [
                        {name: 'Parking Tokens', id: 7},
                        {name: 'Touch N Go', id: 10},
                        {name: 'Visa/Master', id: 11},
                        {name: 'Value Pass', id: 4}
                    ],
                    itemsFull: [],
                    selected: '',
                    loader: false,
                    disable: false,
                    rule: []
                },
                requestedticketentrydatetime: {item: "", formatted: "", rule: []},
                category: {
                    items: [],
                    itemsFull: [],
                    selected: '',
                    loader: false,
                    disable: false,
                    rule: []
                },
                issue: {
                    items: [],
                    itemsFull: [],
                    selected: '',
                    loader: false,
                    disable: false,
                    rule: []
                },
                reasonformanualexit: {item: "", rule: []},
            },
            modal_loader: false,
            focused: false,
            disabled_dates: [],
            topbarcolor: JSON.parse(localStorage.getItem('theme')).topbarcolor
        }
    },

    components: {alertbox, VueTimepicker},

    watch: {
        dialog: {
        handler: function(value) {
            this.modalHandler();
            if(value == true){
                this.handleValue();
            }
        },
        },

        dialogLocal: {
        handler: function(value) {
            this.modalCloseHandler();
        },
        },
    },

    computed: {
        validateStartDate(){
            let classes = '';
            if (this.focused || this.form.requestedticketentrydatetime.item){
                classes += 'primary--text v-label--active';
            }

            if (this.form.requestedticketentrydatetime.item == '' && this.form.requestedticketentrydatetime.rule.length > 0){
                classes += ' error--text';
            }

            return classes;
        },

        validateStartDateMain(){
            let classes = '';
            if (this.focused){
                classes += 'v-input--is-focused primary--text';
            }

            if (this.form.requestedticketentrydatetime.item == '' && this.form.requestedticketentrydatetime.rule.length > 0){
                classes += ' v-input--has-state error--text';
            }

            return classes;
        },
    },

    methods: {
        async getAllOperator(){
            let response = await this.allInfo[0].operator;
            this.form.operator.items = response;
            this.form.operator.itemsFull = response;
        },

        async getAllCarPark(){
            let carpark = [];
            carpark.push({name: 'Select Car Park', CarParkID: ''});
            for (const [index, item] of this.carpark.entries()){
                carpark.push(item);
            }
            this.form.carpark.items = carpark;
        },
        async beforeCreateForm(flag){
            this.form.bayno.rule = [
                v => !!v || `This is required`,
                v => !Number.isNaN(Number(v)) || 'Only integer is allowed'
            ];

            this.form.parkingtokenamountmyr.rule = [
                v => !!v || `This is required`,
                v => !Number.isNaN(Number(v)) || 'Only integer is allowed'
            ];

            this.form.finalparkingamountmyr.rule = [
                v => !!v || `This is required`,
                v => !Number.isNaN(Number(v)) || 'Only integer is allowed'
            ];

            this.form.valuepasspassid.rule = [
                v => !Number.isNaN(Number(v)) || 'Only integer is allowed'
            ];

            let isValidDate = true;
            // if (this.form.requestedticketentrydatetime.item !== ""){
            //     // let entryidfilter = this.allInfo.find(item => item.ParkingWheelLockID == this.form.parkingentryid.item);
            //     isValidDate = moment(this.form.requestedticketentrydatetime.item).format('MM/DD/YYYY HH:mm:ss');
            // }

            this.form.requestedticketentrydatetime.rule = [
                v => !!v || `This is required`,
                v => isValidDate || `The exit date time must be after entry date time`
            ];

            this.form.reasonformanualexit.rule = [
                v => !!v || `This is required`,
            ];

            this.form.pmethod.rule = [
                v => !!v || `This is required`,
            ];

            this.form.category.rule = [
                v => !!v || `This is required`,
            ];

            this.form.issue.rule = [
                v => !!v || `This is required`,
            ];

            //must set this in order to use 'this' as 'self' inside settimeout etc..
            let self = this;

            setTimeout(function () {
                //self.$refs.image.resetValidation();
                //self.$refs.image.reset();

             if (self.$refs.es.validate()) {
                    self.innerModal = true;
                    self.ma.modalInfo = {id: 1, name: 2};
                    self.ma.modal_action_type = flag;
                }
            });
        },

        modalHandler(){
            this.dialogLocal = !this.dialogLocal;
        },

        modalCloseHandler(){
            if (this.dialogLocal == false){
                this.$emit('closed', false);
            }
        },

        async handleValue(){
            this.getAllOperator();
            this.getAllCarPark();
            this.disabled_dates = [];
            this.form.carpark.selected = '';
            this.form.bayno.item = '';
            this.form.bayno.rule = [];
            this.form.requestedticketentrydatetime.rule = [];
            this.form.requestedticketentrydatetime.item = "";
            this.form.requestedticketentrydatetime.formatted = "";

            this.form.parkingentryid.item = "";
            this.form.parkingtokenamountmyr.item = "";
            this.form.valuepasspassid.item = "";
            this.form.finalparkingamountmyr.item = "";
            this.form.pmethod.selected = 7;
            
            this.form.reasonformanualexit.item = "";
            this.form.category.selected = "";
            this.form.issue.selected = "";
            this.form.category.items = this.category;
            this.form.category.itemsFull = this.category;
            this.form.issue.items = this.issue;
            this.form.issue.itemsFull = this.issue;
        },

        //set the action to be sent to watcher to execute the create/edit function
        async onConfirm(value){
            let formattedrequestedticketentrydatetime = moment(this.form.requestedticketentrydatetime.item).unix();
            this.form.requestedticketentrydatetime.formatted = formattedrequestedticketentrydatetime;
            
            if (this.ma.modal_action_type == 'create'){
                this.form.flag = 'createentry';
                this.$emit('confirm', this.form);
            }
            
            this.innerModal = false;
            // this.form.requestedticketentrydatetime.item = '';
            // this.form.requestedticketentrydatetime.formatted = '';
        },

        onClosed(value){
            if (value == false){
                this.innerModal = value;
            }
        },

        execFilter(typ){
            let self = this;

            if (typ == 'operator'){
                this.form.carpark.items = [];
                this.form.carpark.selected = '';

                if (self.form.operator.selected){
                    let itm = this.form[2].itemsFull.filter(i => i.OperatorID == self.form[1].selected);

                    this.form[2].carpark.push({name: 'Select Car Park', CarParkID: ''});

                    for(let i=0; i<itm.length; i++){
                        this.form[2].carpark.push({name: itm[i].name, CarParkID: itm[i].CarParkID});
                    }
                }

                else{
                    this.form[2].carpark = this.form[2].itemsFull;
                }
            }
        },

        searchTimeOut() {
          this.form.requestedticketentrydatetime.item = "";
          clearTimeout(this.timeout);

          // Make a new timeout set to go off in 800ms
          this.timeout = setTimeout(() => {
          let entryidfilter = this.allInfo.find(item => item.ParkingWheelLockID == this.form.parkingentryid.item);
          console.log('entryidfilter', entryidfilter);
          if (entryidfilter != undefined){
              let dte = new Date(moment(entryidfilter.ParkingEntryDateTimeOri).subtract('1', 'days').format('MM/DD/YYYY HH:mm:ss'));
              console.log('entryidfilter.ParkingEntryDateTimeOri', entryidfilter.ParkingEntryDateTimeOri);
            this.disabled_dates = [
                {
                start: null,
                end: dte
                },
            ];
          }
          }, 800);
        }
    }
  }
</script>